/**
 * FlyoutCollapseIcon/index.js
 * desc: icon to collapse flyout content
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const FlyoutCollapseIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="flyout-collapse icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.flyoutCollapse.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg"><path d="M13.326 21.296l.139-8.347 8.346-.138-2.545 2.545 2.462 2.463-3.394 3.394-2.462-2.463-2.546 2.546zM5.521 8.404L3.058 5.94l3.394-3.394L8.915 5.01l2.545-2.546-.138 8.347-8.347.138 2.546-2.545z"/></svg>
    </IconButton>
);


export default FlyoutCollapseIcon;
